import {
  Link as AnchorLink,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@forgeglobal/design-framework';
import { LEGAL_LINKS } from '@tcs/common/assets/constants';
import Footer from '@tcs/create-account/components/Footer';
import RegisterForm from '@tcs/create-account/components/forms/RegisterForm';
import Header from '@tcs/create-account/components/Header';
import useConfig from '@tcs/create-account/hooks/useConfig';
import usePartnerConfig from '@tcs/create-account/hooks/usePartnerConfig';
import { useStyles } from './styles';

const { TERMS_OF_USE, PRIVACY_POLICY } = LEGAL_LINKS;

const RegisterPage = () => {
  const classes = useStyles();
  const config = useConfig();
  const { loading, data } = usePartnerConfig();

  if (loading || config.loading) {
    return null;
  }

  return (
    <>
      <Header data={data?.header} />
      <Card className={classes.card}>
        <CardContent className={classes.cardContainer}>
          <Grid container direction="column" spacing={8}>
            <Grid item container justifyContent="center">
              <Typography variant="h4" data-test-id="title">
                Get Started
              </Typography>
            </Grid>
            <Grid item>
              <RegisterForm />
              <Box mt={1}>
                <Grid item container justifyContent="center" spacing={1}>
                  <Grid item container justifyContent="center">
                    <Typography variant="body1" textAlign="center">
                      Are you opening an account on <br /> behalf of a client?{' '}
                      <a
                        href={`${config.REACT_APP_BASE_PATH}/representative`}
                        className={classes.link}>
                        Click here
                      </a>
                      {'.'}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid container justifyContent="center">
        <Typography
          variant="body2"
          className={classes.policy}
          data-test-id="terms-of-use-text">
          {`By proceeding, you accept Forge Trust Co.’s `}
          <br />
          <AnchorLink href={PRIVACY_POLICY} target="_new">
            Privacy Notice
          </AnchorLink>
          {' and '}
          <AnchorLink href={TERMS_OF_USE} target="_new">
            Website Access Terms & Conditions
          </AnchorLink>
          {'.'}
        </Typography>
      </Grid>
      <Footer data={data?.footer} />
    </>
  );
};

export default RegisterPage;
